import React from 'react';
import {Link} from 'react-router-dom';
import {scenariosData} from 'data/scenarios-data';
import Logos from 'components/ui/logos/logos';
import './select-game.scss';

const SelectGame = () => {
	
	return (
		<div className="SelectGame">
			<Logos />

			<div className="SelectGame-games">
				<div className="SelectGame-game game-1">
					<Link to={scenariosData['game1'].url} className={'SelectGame-gameBtn game1'} />
				</div>
				<div className="SelectGame-game game-3">
					<Link to={scenariosData['game3'].url} className={'SelectGame-gameBtn game3'} />
					<Link to={scenariosData['game4'].url} className={'SelectGame-gameBtn game4'} />
				</div>
				<div className="SelectGame-game game-2">
					<Link to={scenariosData['game2'].url} className={'SelectGame-gameBtn game2'} />
					<Link to={scenariosData['game5'].url} className={'SelectGame-gameBtn game5'} />
				</div>
			</div>
		</div>
	);
};


export default SelectGame;